import { updateIfpApplication } from '@sec-loans-ui/ifp-loans/api/endpoints'
import { wizardDataToApplicationData } from '@sec-loans-ui/ifp-loans/utils'
import { IfpWizardData } from '@sec-loans-ui/ifp-loans/wizard/types'
import { WizardContext } from '@sec-loans-ui/ifp-loans/wizard/wizardMachine'
import { assertValue } from '@shared/helpers'
import { FormStepActions, FormStepState, useFormStepState as useCommonFormStepState } from '@ui-common/state'
import { fromPromise } from 'xstate'

type FormStateContext = Pick<WizardContext, 'applicationId'>

export const useFormStepState = (
  applicationId: string,
  parentActions: FormStepActions<Partial<IfpWizardData>>,
): FormStepState<FormStateContext, Partial<IfpWizardData>> =>
  useCommonFormStepState<FormStateContext, Partial<IfpWizardData>>({ applicationId }, parentActions, {
    actors: {
      save: fromPromise<Partial<IfpWizardData>, { data: Partial<IfpWizardData>; context: FormStateContext }>(
        async ({ input }) => {
          await updateIfpApplication(
            {
              data: wizardDataToApplicationData(input.data),
            },
            assertValue(input.context.applicationId, 'input.context.applicationId'),
          )
          return input.data
        },
      ),
    },
  })
